import React, { useEffect, useState } from "react";
import { Button, Input, Select } from "antd";
import { ErrorToast, SuccessToast } from "../../../../widgets/AppToast";
import { post } from "../../../../services/services";
import { ApiURL } from "../../../../services/apiConstants";

function Crane({ id }) {
  const [loader, set_loader] = useState(false);
  const [errors, set_errors] = useState({});
  const [swl, set_swl] = useState("");
  const [crane_make, set_crane_make] = useState("");
  const [crane_model, set_crane_model] = useState("");
  const [cargo_gear, set_cargo_gear] = useState("");

  const Add_Ships_Api = () => {
    try {
      set_loader(true);
      const FORM_DATA = new FormData();
      FORM_DATA.append("swl", swl);
      FORM_DATA.append("crane_model", crane_model);
      FORM_DATA.append("crane_make", crane_make);
      FORM_DATA.append("cargo_gear", cargo_gear);
      FORM_DATA.append("request_type", "add-edit");
      FORM_DATA.append("ship_id", id);
      post(ApiURL.ship_crane_details_com, FORM_DATA).then((res) => {
        if (res?.status == true) {
          SuccessToast("Congratulation!!", "Details Successfully Saved!!");
          set_loader(false);
          set_errors("");
        } else {
          const errors = res?.errors || {};
          set_errors(errors);
          set_loader(false);
        }
      });
    } catch (error) {
      set_loader(false);
      ErrorToast("Error Occurred", "There was an error during registration.");
    }
  };

  const VIEW_API = () => {
    try {
      const FORM_DATA = new FormData();
      FORM_DATA.append("ship_id", id);
      FORM_DATA.append("request_type", "view");
      post(ApiURL.ship_crane_details_com, FORM_DATA).then((res) => {
        if (res?.status == true) {
          set_crane_make(res?.crane_data?.crane_make);
          set_crane_model(res?.crane_data?.crane_model);
          set_cargo_gear(res?.crane_data?.cargo_gear);
          set_swl(res?.crane_data?.swl);
        } else {
          const errors = res?.errors || {};
          set_errors(errors);
        }
      });
    } finally {
    }
  };

  useEffect(() => {
    if (id) {
      VIEW_API();
    }
  }, [id]);

  return (
    <>
      <h3 style={{ marginTop: "15px", marginBottom: "15px" }}>Crane Information</h3>
      <div className="row">
        <div className="col-6">
          <div className="input-box">
            <label>SWL</label>
            <Input placeholder="SWL" value={swl} onChange={(e) => set_swl(e.target.value)} />
            {errors?.swl && (
              <>
                <span style={{ color: "red" }}>{errors?.swl}</span>
              </>
            )}
          </div>
        </div>
        <div className="col-6">
          <div className="input-box">
            <label>Make</label>
            <Input
              placeholder="Make"
              value={crane_make}
              onChange={(e) => set_crane_make(e.target.value)}
            />
            {errors?.crane_make && (
              <>
                <span style={{ color: "red" }}>{errors?.crane_make}</span>
              </>
            )}
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-6">
          <div className="input-box">
            <label>Cargo Gear</label>
            <Select
              placeholder="-----  Cargo Gear  ------"
              style={{ width: "100%" }}
              value={cargo_gear}
              onChange={(value) => set_cargo_gear(value)}
            >
              <Select.Option value="1">1</Select.Option>
              <Select.Option value="2">2</Select.Option>
              <Select.Option value="3">3</Select.Option>
              <Select.Option value="4">4</Select.Option>
              <Select.Option value="5">5</Select.Option>
              <Select.Option value="6">6</Select.Option>
              <Select.Option value="7">7</Select.Option>
              <Select.Option value="8">8</Select.Option>
              <Select.Option value="9">9</Select.Option>
              <Select.Option value="10">10</Select.Option>
            </Select>
            {errors?.cargo_gear && (
              <>
                <span style={{ color: "red" }}>{errors?.cargo_gear}</span>
              </>
            )}
          </div>
        </div>
        <div className="col-6">
          <div className="input-box">
            <label>Model</label>
            <Input
              placeholder="Model"
              value={crane_model}
              onChange={(e) => set_crane_model(e.target.value)}
            />
            {errors?.crane_model && (
              <>
                <span style={{ color: "red" }}>{errors?.crane_model}</span>
              </>
            )}
          </div>
        </div>
      </div>

      <div className="input-box" style={{ marginTop: "15px" }}>
        <Button type="primary" onClick={Add_Ships_Api} loading={loader}>
          save
        </Button>
      </div>
    </>
  );
}

export default Crane;
